// extracted by mini-css-extract-plugin
module.exports = {"legendRoot":"xNhuw3qB","title":"BqYuDIrx","list":"vUuhV5Gi","item":"_2WRtkMXO","itemHovered":"sZw8whw9","asset":"_7EUvcWt","dot":"Amm9liAi","label":"DXLLZ6DC","value":"QDKhwaiH"};